const launchersContainer = {
  props: {
    dynamicClass: ".launchers-container.dynamicLoading",
    className: "launchers-container",
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-launchersContainer.css", this.props.dynamicClass);

    const parentElement = Array.from(document.getElementsByClassName(this.props.className));
    if (parentElement) {
      parentElement.forEach((element) => {
        let swiperInstance = null;
        const swiperElement = element?.querySelector(".swiper");

        const initSwiper = () => {
          if (swiperElement && window.innerWidth <= 1024) {
            swiperInstance = new window.Swiper(swiperElement, {
              slidesPerView: 2.5,
              freeMode: false,
              loop: false,
              spaceBetween: "16",
            });
          }
        };

        const destroySwiper = () => {
          if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
          }
        };

        initSwiper();

        window.addEventListener("resize", () => {
          if (swiperElement && window.innerWidth <= 1024) {
            if (!swiperInstance) {
              initSwiper();
            }
          } else {
            destroySwiper();
          }
        });
      });
    }
  },
};

export default launchersContainer;
